












import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import {
  NaraDto,
  ProductDto
} from '@eurogast/hub-client-typescript';
import { namespace } from 'vuex-class';
import { CART } from '@/store/types';
import AutoCompleteProduct from '@/search-form/search-result/AutoCompleteProduct.vue';

const cart = namespace(CART);

@Component({
  components: {AutoCompleteProduct}
})
export default class AutoCompleteProducts extends Vue {

  get naraMap(): Map<string, string[]> {
    const naraMap = new Map<string, string[]>();
    this.naras.forEach((el) => naraMap.set(el.sku, el.naraCodes));
    return naraMap;
  }

  @Prop({required: false, default: () => []})
  public products: ProductDto[];

  @Prop({required: false, default: () => []})
  public naras: NaraDto[];
}
